import logo from '../../../../assets/logo.webp';
import { GAME_CONFIG } from '../../data/gameConfig';
import { getLifeFeedback } from '../../data/lifeFeedback';

const INITIAL_LIFE = getLifeFeedback(0, GAME_CONFIG.time.initial);

export default function GameHud({ gameState, scoreTextRef, streakTextRef, multiplierTextRef, rhythmHudRef, onPause }) {
  if (!['playing', 'countdown', 'paused'].includes(gameState)) return null;
  const bind = (key) => (node) => { rhythmHudRef.current[key] = node; };

  return (
    <div className="rhythm-hud">
      <div className="rhythm-score-lockup">
        <img src={logo} alt="Ñaca Ñaca" width="52" height="56" draggable="false" />
        <div><span className="rhythm-label">Puntos</span><strong ref={scoreTextRef} className="rhythm-score">0</strong></div>
      </div>
      <div className="rhythm-life" ref={bind('life')} data-danger="false">
        <div className="rhythm-life-heading">
          <span aria-hidden="true">♥</span>
          <span>Vida</span>
          <small>Ahora</small>
        </div>
        <meter
          ref={bind('lifeMeter')}
          className="rhythm-semantic-meter"
          min="0"
          max="100"
          value={INITIAL_LIFE.percent}
          aria-label="Vida restante"
        />
        <span className="rhythm-life-track" aria-hidden="true">
          <span ref={bind('lifeFill')} style={{ transform: `scaleX(${INITIAL_LIFE.percent / 100})` }} />
        </span>
        <strong ref={bind('lifeLabel')}>{INITIAL_LIFE.label}</strong>
      </div>
      <div className="rhythm-combo" ref={bind('combo')} data-visible="false" data-tier="1" aria-label="Racha de aciertos">
        <span className="rhythm-combo-flare" aria-hidden="true" />
        <strong ref={streakTextRef}>0</strong>
        <span className="rhythm-combo-caption">racha <b ref={multiplierTextRef}>×1</b></span>
      </div>
      <button type="button" onClick={onPause} className="rhythm-pause" aria-label="Pausar partida" disabled={gameState === 'paused'}><span aria-hidden="true">Ⅱ</span></button>
      <p className="rhythm-danger-label" ref={bind('danger')} hidden>¡Te alcanza!</p>
    </div>
  );
}
